import React, { useState } from "react";
import { Box } from "@mui/material";
import Select, { TOption, TOptionType } from "../../../Components/Select";
import { getDeviceOptions, getValueAttributeOptions } from "../utils";
import { IDevice } from "../../devices/types";
import { TNumericCondition } from "./types";
import NumericConditionPicker, {
  TNumericOperator,
} from "../../../Components/NumericConditionPicker";
import { useTranslation } from "react-i18next";

interface INumericConditionFormProps {
  condition: TNumericCondition;
  devices: IDevice[];
  onChange: (numericCondition: TNumericCondition) => void;
}

const NumericConditionForm = (props: INumericConditionFormProps) => {
  const { condition, devices, onChange } = props;
  const device_id = condition.device_id || devices[0].id;

  const [attributeOptions, setAttributeOptions] = useState<
    TOption<TOptionType>[]
  >(getValueAttributeOptions(devices, device_id));

  const [numericCondition, setNumericCondition] = useState<TNumericCondition>({
    device_id: device_id,
    attribute: attributeOptions[0].value as string,
    ...condition,
  });
  const { t } = useTranslation();

  const updateNumericCondition = (newNumericCondition: TNumericCondition) => {
    setNumericCondition(newNumericCondition);
    onChange(newNumericCondition);
  };

  return (
    <>
      <Select
        fullWidth
        label={t("Device")}
        options={getDeviceOptions(devices)}
        value={numericCondition.device_id}
        onChange={(event) => {
          const newDeviceId = parseInt(event.target.value);
          const newAttributeOptions = getValueAttributeOptions(
            devices,
            newDeviceId
          );
          setAttributeOptions(newAttributeOptions);
          updateNumericCondition({
            ...numericCondition,
            device_id: newDeviceId,
            attribute: newAttributeOptions[0].value as string,
          });
        }}
        margin="none"
        data-cy="numeric-condition-select-device"
      />
      <Box gap={1} display="flex" flexDirection="row">
        <Select
          label={t("Attribute")}
          value={numericCondition.attribute}
          options={attributeOptions}
          onChange={(event) => {
            updateNumericCondition({
              ...numericCondition,
              attribute: event.target.value,
            });
          }}
          margin="none"
          style={{ width: "70%" }}
          data-cy="numeric-condition-select-attribute"
        />
        <NumericConditionPicker
          label={t("Condition")}
          operator={numericCondition.operator}
          value={numericCondition.value}
          onConditionChange={(operator: TNumericOperator, value: number) => {
            updateNumericCondition({
              ...numericCondition,
              operator: operator,
              value: value,
            });
          }}
          style={{ width: "30%" }}
          data-cy="numeric-condition-condition-picker"
        />
      </Box>
    </>
  );
};

export default NumericConditionForm;
